package org.example.project.ui

import org.example.project.client.model.ActivityResponse
import org.example.project.client.model.UserProfileResponse

sealed interface EditorNavigationState {
    data object Loading : EditorNavigationState
    data object Login : EditorNavigationState
    data class AccessDenied(val user: UserProfileResponse) : EditorNavigationState
    data object ActivityList : EditorNavigationState
    data class ActivityForm(val editingActivity: ActivityResponse? = null) : EditorNavigationState
    data object Planner : EditorNavigationState
}
